import React from 'react';
import { CurrentUserPosition } from './styles';
import RankBadge from './RankBadge';
import { useFortniteLeaderboardContext } from './Context/Context';

const LoggedUserPosition = () => {
  const { isRanked, isPanel } = useFortniteLeaderboardContext();
  return (
    <table>
      <tbody>
        <CurrentUserPosition isRanked={isRanked} isPanel={isPanel}>
          {
            isRanked ? (
              <>
                <td>1</td>
                <td>
                  <RankBadge rank="Gold_1" />
                  {!isPanel && 'Gold 1'}
                </td>
                <td>Player 1</td>
              </>
            ) : (
              <>
                <td>1</td>
                <td>Player 1</td>
                <td>100</td>
                <td>100</td>
                <td>100</td>
                <td>100</td>
              </>
            )
          }
        </CurrentUserPosition>
      </tbody>
    </table>
  );
};

export default LoggedUserPosition;
